// extracted by mini-css-extract-plugin
module.exports = {"colorD20":"StarsRating_colorD20__4Xd4j"};